module.exports = __webpack_public_path__ + "assets/graphs.bb8154c6.svg";